export default "__VITE_ASSET__BWD_UV6g__"